/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

const blocks = () => css`
    .blocks {
  display: flex;
  align-items: center;
  position: relative;
  justify-content: center;
}

.block {
  --sz: 60px;
  --tX: 0;
  --animation: 700ms cubic-bezier(0.3, 0.5, 0.4, 0.9) infinite alternate-reverse;
  --hm: 4px;
  height: var(--sz);
  width: var(--sz);
  border-radius: 50%;
  transform: translateX(var(--tX));
  mix-blend-mode: normal;
  position: relative;
}

.orange {
  background: #1a71b9;
  margin-right: var(--hm);
  animation: attract-orange var(--animation);
  border-bottom-left-radius: 0px;
  z-index: 1;
}

.blue {
  background: rgba(108, 184, 244, 0.7);
  margin-left: var(--hm);
  animation: attract-blue var(--animation);
  z-index: 2;
}
.loading-text {
  font-size: 16px;
  color: #555; /* Starting dark gray color */
  animation: loading-fade 1.5s ease-in-out infinite;
  text-align: center;
  margin-top: 2rem;
}

@keyframes loading-fade {
  0%, 100% {
    color: #555; /* Darker gray */
  }
  50% {
    color: #ccc; /* Lighter gray */
  }
}

 @keyframes attract-orange {
    to {
      transform: translateX(calc(var(--sz) / 3)); /* Reduced movement */
    }
  }

  @keyframes attract-blue {
    to {
      transform: translateX(calc(var(--sz) / -3)); /* Reduced movement */
    }
  }
`


function SiteLoading(props) { 
    return (
        <div className="flexcenter width100 height100">
            <div className="flexcolumn aligncenter justifycenter" css={blocks}>
                <div className="blocks">
                    <div className="block orange"></div>
                    <div className="block blue"></div>
                </div>
                <div className="loading-text">Loading...</div>
            </div>
            <style>
                {`
                .sidebar, nav{display:none;}
                `}
            </style>
            <div className="quickstart-bg"></div>
        </div>
    );
}

export default SiteLoading;